export class CategoriaProducto {
            public codCategoriaProducto: number;
            public codCategoriaProductoErp: string;
            public codEmpresa: number;
            public descripcion: string;

            constructor() { }
    }
